// extracted by mini-css-extract-plugin
var _1 = "ImagesGallery_compact__3VuUP";
var _2 = "ImagesGallery_container__WI7kh";
var _3 = "ImagesGallery_gray__rb7dP";
var _4 = "ImagesGallery_image__TeVCi";
var _5 = "ImagesGallery_imageCompact__dl+0f";
var _6 = "ImagesGallery_imagePlaceholder__YTqHA";
var _7 = "ImagesGallery_square__2UdpO";
export { _1 as "compact", _2 as "container", _3 as "gray", _4 as "image", _5 as "imageCompact", _6 as "imagePlaceholder", _7 as "square" }
